import { withStyles } from "@material-ui/core";
import React from "react";
import Events from "../../../../../utilities/EventEmitter";
import Tooltip from "../../../../common/StyledToolTip";
import { KPI_NAME } from "../constants";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginLeft: 24,
    "&:not(:last-child)": {
      marginRight: 24,
    },
    "&:last-child": {
      marginRight: 8,
    },
  },
  kpiSubGroupTag: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    lineHeight: "19px",
    width: "max-content",
  },
  value: {
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 500,
    lineHeight: "22px",
    fontSize: theme.headerTextFontSize,
  },
  dividerStyle: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    margin: "1 6 0 6",
  },
  kpiValuePositive: {
    color: theme.KPI.KPISingleValue,
  },
  kpiValueNegative: {
    color: theme.error,
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
  },
});

/*
  unary plus is the fastest and preferred way of converting something into a number, because it does not perform any other operations on the number.
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Unary_plus#:~:text=Description-,Unary%20plus%20(%2B),if%20it%20isn%27t%20already.
*/
const getKPIColorClass = ({ classes, subGroupData, kpiValue, index }) => {
  const { kpiName, values } = subGroupData;
  const [actual, plan] = values;
  let value = +kpiValue;
  if (!value) {
    return "";
  }
  switch (kpiName) {
    case KPI_NAME.RETURN:
      return value > 0 ? classes.kpiValueNegative : classes.kpiValuePositive;
    case KPI_NAME.SPH:
    case KPI_NAME.BPH:
      if (index > 0) {
        return "";
      }
      return plan.value < actual.value
        ? classes.kpiValuePositive
        : classes.kpiValueNegative;
    case KPI_NAME.OT:
      return value > 0 ? classes.kpiValueNegative : "";
    default:
      return "";
  }
};

const KPISubGroup = ({ classes, subGroupData, groupIndex }) => {
  const lastValueIndex = subGroupData.values.length - 1;
  const subGroupValues = subGroupData.values.map((subGroup) => subGroup.value);
  const openReturnShipmentModel = () => {
    Events.emit("OpenReturnShipments");
  }
  return (
    <Tooltip title={subGroupData.description} key={`KPISubGroup-${groupIndex}`}>
      <div className={classes.container}>
        <div>
          {subGroupValues.map((kpiValue, index) => {
            const kpiClass = getKPIColorClass({
              classes,
              subGroupData,
              kpiValue,
              index,
            });
            return (
              <React.Fragment key={`value-${index}`}>
                <span className={`${classes.value} ${kpiClass}`}>
                  {kpiValue ?? 0}
                </span>
                {index !== lastValueIndex && (
                  <span className={classes.dividerStyle} />
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className={classes.kpiSubGroupTag}>
          {subGroupData.kpiName === KPI_NAME.RETURN ? (
            <div
              className={classes.link}
              onClick={openReturnShipmentModel}
            >
              {subGroupData.kpiName}
            </div>
          ) : (
            subGroupData.kpiName
          )}
        </div>
      </div>
    </Tooltip>
  );
};
export default withStyles(styles)(KPISubGroup);
